<template>
  <section class='content'>
    <ranking-modal></ranking-modal>
    <red-returns></red-returns>
    <amazon-token-renewal-reminder></amazon-token-renewal-reminder>
    <div class="row">
      <div class="col-xs-12">
        <multiselect
          v-model="store"
          :options="getStoreOptions"
          placeholder=""
          label="name"
          track-by="id"
          @input="updateStore"
          :allow-empty="false"
        >
          <template slot="option" slot-scope="props">
            <template v-if="props.option.id !== 0">
              <div class="option__desc">
              <span class="option__title">
                {{props.option.name}}, {{props.option.street}} {{props.option.street_no}}, {{props.option.zip_code}} {{props.option.city}}
              </span>
                <br/>
                <span class="small text-muted">{{'store_number' | translate}}: {{props.option.store_number}}</span>
              </div>
            </template>
            <div v-else class="option__desc">
               <span class="option__title">
                  {{props.option.name}}
               </span>
            </div>
          </template>
        </multiselect>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-3 col-sm-6">
        <div class="input-group">
          <div class="input-group-addon">
            {{'period' | translate}}
          </div>
          <date-range-picker :startDate="dashboardStartRange" :endDate="dashboardEndRange" id="ordertime" @pepe="onDateRangeChanged"></date-range-picker>
        </div>
      </div>
      <div class="col-xs-9">
        <div class="col-sm-12 col-xs-12 text-right">
          <ul class="pagination pagination-sm no-margin" lang="de">
            <li class="paginate_button">
              <button
                @click="setDate('today')"
                :class="['paginate_button page-link', activeDateFilter === 'today' ? 'active' : '']"
              >
                {{'today' | translate | capitalize}}
              </button>
            </li>
            <li class="paginate_button">
              <button
                @click="setDate('yesterday')"
                :class="['paginate_button page-link', activeDateFilter === 'yesterday' ? 'active' : '']"
              >
                {{'yesterday' | translate | capitalize}}
              </button>
            </li>
            <li class="paginate_button">
              <button
                @click="setDate('thisMonth')"
                :class="['paginate_button page-link', activeDateFilter === 'thisMonth' ? 'active' : '']"
              >
                {{'this_month' | translate}}
              </button>
            </li>
            <li class="paginate_button">
              <button
                @click="setDate('lastMonth')"
                :class="['paginate_button page-link', activeDateFilter === 'lastMonth' ? 'active' : '']"
              >
                {{'last_month' | translate}}
              </button>
            </li>
            <li class="paginate_button">
              <button
                @click="setDate('thisYear')"
                :class="['paginate_button page-link', activeDateFilter === 'thisYear' ? 'active' : '']"
              >
                {{'this_year' | translate}}
              </button>
            </li>
            <li class="paginate_button">
              <button
                @click="setDate('lastYearSameTime')"
                :class="['paginate_button page-link', activeDateFilter === 'lastYearSameTime' ? 'active' : '']"
              >
                {{'last_year_same_time' | translate}}
              </button>
            </li>
            <li class="paginate_button">
              <button
                @click="setDate('lastYear')"
                :class="['paginate_button page-link', activeDateFilter === 'lastYear' ? 'active' : '']"
              >
                {{'last_year' | translate}}
              </button></li>
            <li class="paginate_button">
              <button
                @click="setDate('total')"
                :class="['paginate_button page-link', activeDateFilter === 'total' ? 'active' : '']"
              >
                {{'total' | translate}}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row pt-10">
      <order-boxes
        :title="'orders'"
        type="secondary"
        icon="fa-shopping-bag"
        :items="performance.orders"
      >
      </order-boxes>
      <performance-box
        bootstrapClass="col-lg-3 col-md-6"
        :title="'returns'"
        type="warning"
        icon="fa-retweet"
        :items="performance.returns"
      >
      </performance-box>
      <performance-box
        bootstrapClass="col-lg-3 col-md-6"
        :title="'cancellations'"
        type="danger"
        icon="fa-ban"
        :items="performance.cancellations"
      >
      </performance-box>
      <performance-box
        bootstrapClass="col-lg-3 col-md-6"
        :title="'ranking'"
        :type="performance.ranking.status"
        icon="fa-star"
        :items="performance.ranking"
      >
      </performance-box>
    </div>
    <div class="row">
      <div class="col-lg-9 col-md-12">
        <price-box :price="performance.orders" :priceMargin="priceMargin" :class="[positiveMargin !== true ? 'hide' : 'show']"></price-box>
        <connected-retail v-if="connectedRetail.orders > 0" :connectedRetail="connectedRetail"></connected-retail>
        <price-box-mp :channelData="performance.orders.channels"></price-box-mp>
        <stats-report :orders="performance.orders"></stats-report>
        <tamaris-report :stores="this.$store.getters.stores" :tamaris="tamarisResponse"></tamaris-report>
      </div>
      <div class="col-lg-3 col-md-12">
        <performance-box
          :title="'tamaris_status'"
          :type="performance.tamaris_ranking.status"
          icon="fa-star"
          :items="performance.tamaris_ranking"
        >
        </performance-box>
        <div class="row">
          <div class="col-lg-12 col-md-6">
            <div class="info-box">
              <span class="info-box-icon bg-warning-active"><i class="fa fa-reply"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">{{'returns_in_delivery' | translate}}</span>
                <span class="info-box-number">{{returnCount}} {{'returns_pending' | translate}}</span>
              </div>
            </div>
          </div>
         </div>
         </div>
      </div>
  </section>
</template>
<script>
import OrdersComponent from '../tools/OrderComponent.vue'
import OrderBoxesComponent from '../tools/OrderBoxesComponent.vue'
import ErrorBoxComponent from '../tools/ErrorBox.vue'
import DateRangePicker from '../tools/DateRangePicker.vue'
export default {
  name: 'Dashboad',
  data () {
    return {
      activeDateFilter: window.localStorage.getItem('activeDateFilter') ? window.localStorage.getItem('activeDateFilter') : 'today',
      dashboardSelectedStart: window.localStorage.getItem('dashboardSelectedStart') ? window.localStorage.getItem('dashboardSelectedStart') : moment().format('YYYY-MM-DD'),
      dashboardSelectedEnd: window.localStorage.getItem('dashboardSelectedEnd') ? window.localStorage.getItem('dashboardSelectedEnd') : moment().format('YYYY-MM-DD'),
      dashboardStartRange: window.localStorage.getItem('dashboardSelectedStart') ? moment(window.localStorage.getItem('dashboardSelectedStart')) : moment(),
      dashboardEndRange: window.localStorage.getItem('dashboardSelectedEnd') ? moment(window.localStorage.getItem('dashboardSelectedEnd')) : moment(),
      error: false,
      merchantData: [],
      originalData: [],
      percentage: 0,
      returnCount: 0,
      priceMargin: 0,
      tamarisData: [],
      tamarisResponse: [],
      positiveMargin: true,
      product_errors: 0,
      active_products: 0,
      inactive_products: 0,
      last_import: '',
      products: 1542,
      translate: this.$parent.translate,
      sales: {},
      priceArrangement: {},
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      },
      connectedRetail: [],
      response: {},
      performance: {
        cancellations: {
          '7_days': {
            cancellations: '',
            items: '',
            percentage: ''
          },
          '14_days': {
            cancellations: '',
            items: '',
            percentage: ''
          },
          '30_days': {
            cancellations: '',
            items: '',
            percentage: ''
          },
          '90_days': {
            cancellations: '',
            items: '',
            percentage: ''
          },
          channels: {
            amazon: {
              '7_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '14_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '30_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '90_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              total: {
                cancellations: '',
                items: '',
                percentage: ''
              }
            },
            ebay: {
              '7_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '14_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '30_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '90_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              total: {
                cancellations: '',
                items: '',
                percentage: ''
              }
            },
            schuhede: {
              '7_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '14_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '30_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '90_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              total: {
                cancellations: '',
                items: '',
                percentage: ''
              }
            },
            spartoo: {
              '7_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '14_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '30_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '90_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              total: {
                cancellations: '',
                items: '',
                percentage: ''
              }
            },
            zalando: {
              '7_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '14_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '30_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              '90_days': {
                cancellations: '',
                items: '',
                percentage: ''
              },
              total: {
                cancellations: '',
                items: '',
                percentage: ''
              }
            }
          },
          total: {
            cancellations: '',
            items: '',
            percentage: ''
          }
        },
        orders: {
          total: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          month: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          last_month: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          '7_days': {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          '30_days': {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          yesterday: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          channels: {
            amazon: {
              yesterday: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              total: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              last_month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '7_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '30_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              }
            },
            ebay: {
              yesterday: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              total: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              last_month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '7_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '30_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              }
            },
            schuhede: {
              yesterday: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              total: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              last_month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '7_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '30_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              }
            },
            spartoo: {
              yesterday: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              total: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              last_month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '7_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '30_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              }
            },
            zalando: {
              yesterday: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              total: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              last_month: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '7_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
              '30_days': {
                items: '',
                amount: '',
                average: '',
                orders: ''
              }
            }
          }
        },
        ranking: {
          points: '',
          position: '',
          rank: '',
          status: ''
        },
        tamaris_ranking: {
          points: '',
          position: '',
          rank: '',
          status: ''
        },
        returns: {
          '30_days': {
            items: '',
            returns: '',
            percentage: ''
          },
          '90_days': {
            items: '',
            returns: '',
            percentage: ''
          },
          last_month: {
            items: '',
            returns: '',
            percentage: ''
          },
          month_before_last_month: {
            items: '',
            returns: '',
            percentage: ''
          },
          total: {
            items: '',
            returns: '',
            percentage: ''
          },
          channels: {
            amazon: {
              '30_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              '90_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              month_before_last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              total: {
                items: '',
                returns: '',
                percentage: ''
              }
            },
            ebay: {
              '30_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              '90_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              month_before_last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              total: {
                items: '',
                returns: '',
                percentage: ''
              }
            },
            zalando: {
              '30_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              '90_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              month_before_last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              total: {
                items: '',
                returns: '',
                percentage: ''
              }
            },
            spartoo: {
              '30_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              '90_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              month_before_last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              total: {
                items: '',
                returns: '',
                percentage: ''
              }
            },
            schuhede: {
              '30_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              '90_days': {
                items: '',
                returns: '',
                percentage: ''
              },
              last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              month_before_last_month: {
                items: '',
                returns: '',
                percentage: ''
              },
              total: {
                items: '',
                returns: '',
                percentage: ''
              }
            }
          }
        }
      },
      store: {
        id: 0,
        name: this.$options.filters.translate('all_stores', this.$store.getters.language)
      },
      selectedStore: 0
    }
  },
  components: {
    latestOrders: OrdersComponent,
    orderBoxes: OrderBoxesComponent,
    errorBox: ErrorBoxComponent,
    dateRangePicker: DateRangePicker
  },
  methods: {
    setDate (dateString) {
      switch (dateString) {
        case 'today':
          this.dashboardSelectedStart = moment().format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
        case 'yesterday':
          this.dashboardSelectedStart = moment().subtract(1, 'day').format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().subtract(1, 'day').format('YYYY-MM-DD')
          break
        case 'thisMonth':
          let dateThisMonth = this.prepareDate()
          this.dashboardSelectedStart = moment(`${dateThisMonth.year}-${dateThisMonth.month}-01`).format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
        case 'lastMonth':
          let lastMonth = moment().subtract(1, 'month')
          let lastMonthData = {"day": lastMonth.format('DD'), "month": lastMonth.format('MM'), "year": lastMonth.format('YYYY')}
          let monthMaxDays = new Date(lastMonthData.year, lastMonthData.month, 0).getDate()
          this.dashboardSelectedStart = moment(`${lastMonthData.year}-${lastMonthData.month}-01`).format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment(`${lastMonthData.year}-${lastMonthData.month}-${monthMaxDays}`).format('YYYY-MM-DD')
          break
        case 'lastYearSameTime':
          let lastYear = moment().subtract(1, 'year')
          let lastYearData = {"day": lastYear.format('DD'), "month": lastYear.format('MM'), "year": lastYear.format('YYYY')}
          this.dashboardSelectedStart = moment(`${lastYearData.year}-01-01`).format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment(`${lastYearData.year}-${moment().format('MM')}-${moment().format('DD')}`).format('YYYY-MM-DD')
          break
        case 'lastYear':
          let data = {"day": moment().subtract(1, 'year').format('DD'), "month": moment().subtract(1, 'year').format('MM'), "year": moment().subtract(1, 'year').format('YYYY')}
          this.dashboardSelectedStart = moment(`${data.year}-01-01`).format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment(`${data.year}-12-31`).format('YYYY-MM-DD')
          break
        case 'thisYear':
          let currentYear  = this.prepareDate()
          this.dashboardSelectedStart = moment(`${currentYear.year}-01-01`).format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
        case 'total':
          this.dashboardSelectedStart = moment("2017-01-01T00:00:00").format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
      }
      this.activeDateFilter = dateString
      this.updateData()
      this.getConnectedRetail()
    },
    prepareDate () {
      return {"day": moment().format('DD'), "month": moment().format('MM'), "year": moment().format('YYYY')}
    },
    onDateRangeChanged (picker) {
      this.dashboardStartRange = picker.startDate
      this.dashboardEndRange = picker.endDate

      this.dashboardSelectedStart = this.dashboardStartRange.format('YYYY-MM-DD')
      this.dashboardSelectedEnd = this.dashboardEndRange.format('YYYY-MM-DD')
      this.activeDateFilter = ''

      window.localStorage.setItem('activeDateFilter', this.activeDateFilter)

      this.updateData()
      this.getConnectedRetail()
    },
    tamarisOnDataCalled () {
      if(this.store.id === 0) {
        this.tamarisData = this.$store.getters.stores.flatMap(x => x.store_number)
      } else {
        this.tamarisData = [this.store.store_number]
      }
      API.get('statistics/tamarisPerformance?store_numbers=' + JSON.stringify(this.tamarisData))
        .then(response => {
          this.tamarisResponse = response.data.data
        })
    },
    getConnectedRetail () {
      window.localStorage.setItem('dashboardSelectedStart', this.dashboardSelectedStart)
      window.localStorage.setItem('dashboardSelectedEnd', this.dashboardSelectedEnd)
      window.localStorage.setItem('activeDateFilter', this.activeDateFilter)

      API.get(`statistics/connected-retail-stats?start=${this.dashboardSelectedStart}&end=${this.dashboardSelectedEnd}`)
        .then(response => {
          this.connectedRetail = response.data
        })
    },
    calculatePriceMargin () {
      this.priceMargin = this.performance.orders.amount_diff / (this.performance.orders.expected_amount/100)
      this.priceMargin > -1000 ? this.positiveMargin = true : this.positiveMargin = false
    },
    update (value) {
      this.percentage = value >= 1.5 ? 1.5 : 1.0
      this.error = true
    },
    calculateTime () {
      let time = Math.ceil(moment().diff(moment().startOf('hour'), 'minutes') / 5)
      time++
      time = time + ((time - 1) * 4)
      let callback = moment().minutes(time).seconds(0)
      return (callback.diff(moment().seconds(0), 'milliseconds'))
    },
    updateData () {
      this.orders = this.ordersBack

      window.localStorage.setItem('dashboardSelectedStart', this.dashboardSelectedStart)
      window.localStorage.setItem('dashboardSelectedEnd', this.dashboardSelectedEnd)
      window.localStorage.setItem('activeDateFilter', this.activeDateFilter)

      API.get(`statistics/performance?start=${this.dashboardSelectedStart}&end=${this.dashboardSelectedEnd}${this.store.id !== 0 ? `&store_id=${this.store.id}` : ''}`)
        .then(response => {
          this.performance = response.data
          this.calculatePriceMargin()
        })
      API.get('statistics/live/sales', {})
        .then(response => {
          this.merchantData = response.data.data
          this.originalData = response.data.data
          setTimeout(this.updateData, this.calculateTime())
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateStore (e) {
      this.tamarisOnDataCalled()
      API.get(`statistics/performance?start=${this.dashboardSelectedStart}&end=${this.dashboardSelectedEnd}${this.store.id !== 0 ? `&store_id=${e.id}` : ''}`)
        .then(response => {
          this.performance = response.data
          this.calculatePriceMargin()
        })
    },
  },
  computed: {
    getStoreOptions () {
      return [{id: 0, name: this.$options.filters.translate('all_stores', this.$store.getters.language)}].concat(this.$store.getters.stores)
    }
  },
  mounted () {
    this.$nextTick(() => {
      API.get('statistics/live/sales', {})
        .then(response => {
          this.merchantData = response.data.data[0]
          this.originalData = response.data.data[0]
          setTimeout(this.updateData, this.calculateTime())
        })
        .catch(error => {
          console.log(error)
        })
      API.get(`statistics/performance?start=${this.dashboardSelectedStart}&end=${this.dashboardSelectedEnd}${this.store.id !== 0 ? `&store_id=${this.store.id}` : ''}`)
        .then(res => {
          this.performance = res.data
          this.calculatePriceMargin()
        })
        .catch(error => {
          console.log(error)
        })
      API.get('statistics/return/status')
        .then(res => {
          this.returnCount = res.data.inDeliveryCount
        })
      this.tamarisOnDataCalled()
      this.getConnectedRetail()
      window.localStorage.setItem('orderPage', 1)
      window.localStorage.setItem('orderStatus', 'open')
      window.localStorage.setItem('orderChannel', 0)
      window.localStorage.setItem('orderSku', '')
      window.localStorage.setItem('orderQBId', '')
      window.localStorage.setItem('orderUsername', '')
      window.localStorage.setItem('sortType', 'asc')
      window.localStorage.setItem('selectedEnd', '')
      window.localStorage.setItem('selectedStart', '')
      window.localStorage.setItem('dashboardSelectedStart', this.dashboardSelectedStart)
      window.localStorage.setItem('dashboardSelectedEnd', this.dashboardSelectedEnd)
      window.localStorage.setItem('activeDateFilter', this.activeDateFilter)
      if (this.$store.dispatch('checkPermissions', 'co_dashboard')) {
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 4 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 4;
    -webkit-overflow-scrolling: touch;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Dashboard.vue